(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5417],{

/***/ 24656:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/catalog/[slug]",
      function () {
        return __webpack_require__(78110);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 78110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_ForCWV_Wrappers_MainLayout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75947);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63385);
/* harmony import */ var _components_ForCWV_CustomCategoryPage__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57707);
/* harmony import */ var _components_shared_ReCaptchaWrapper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2598);










var Catalog = function(pageProps) {
    var dbName = pageProps.dbName, domain = pageProps.domain, productsList = pageProps.productsList, titleCategory = pageProps.titleCategory, tmp = pageProps.metaOptions, ref = tmp === void 0 ? {} : tmp, _meta_title = ref.meta_title, meta_title = _meta_title === void 0 ? "" : _meta_title, _meta_description = ref.meta_description, meta_description = _meta_description === void 0 ? "" : _meta_description, _meta_keywords = ref.meta_keywords, meta_keywords = _meta_keywords === void 0 ? "" : _meta_keywords, _image = ref.image, image = _image === void 0 ? "" : _image, _tw_title = ref.tw_title, tw_title = _tw_title === void 0 ? "" : _tw_title, _tw_desc = ref.tw_desc, tw_desc = _tw_desc === void 0 ? "" : _tw_desc, _fb_title = ref.fb_title, fb_title = _fb_title === void 0 ? "" : _fb_title, _fb_desc = ref.fb_desc, fb_desc = _fb_desc === void 0 ? "" : _fb_desc, _y_key = ref.y_key, y_key = _y_key === void 0 ? "" : _y_key, selectedRate = pageProps.selectedRate, selectedLocale = pageProps.selectedLocale, brandList = pageProps.brandList, categoryDescription = pageProps.categoryDescription, translationsData = pageProps.translationsData, breadcrumb = pageProps.breadcrumb, blockStyleHandle = pageProps.blockStyleHandle, hasFilterInQuery = pageProps.hasFilterInQuery, whichOneRender = pageProps.whichOneRender, backOrderValue = pageProps.backOrderValue, getBuilderData = pageProps.getBuilderData, showBuilderData = pageProps.showBuilderData, currencies = pageProps.currencies, showWishlist = pageProps.showWishlist, showCart = pageProps.showCart, isMobile = pageProps.isMobile, recaptchaActive = pageProps.recaptchaActive, recaptchaKey = pageProps.recaptchaKey, siteName = pageProps.siteName, defaultLangCode = pageProps.defaultLangCode, locales = pageProps.locales;
    var ref1 = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)(), asPath = ref1.asPath, locale = ref1.locale;
    var meta_url = asPath.split("?")[0];
    var canonicalUrl = "".concat(dbName).concat(locale !== "catchAll" && locale !== defaultLangCode ? "/" + selectedLocale : "").concat(meta_url);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_ReCaptchaWrapper__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        recaptchaActive: recaptchaActive,
        recaptchaKey: recaptchaKey,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ForCWV_Wrappers_MainLayout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, pageProps), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_4___default()), {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                                children: meta_title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                name: "title",
                                content: meta_title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                name: "description",
                                content: meta_description
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                name: "keywords",
                                content: meta_keywords
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                name: "generator",
                                content: "Zegashop.com"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                name: "robots",
                                content: "index, follow"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                name: "twitter:title",
                                content: tw_title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                name: "twitter:description",
                                content: tw_desc
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                name: "twitter:image",
                                content: (0,_helper__WEBPACK_IMPORTED_MODULE_5__/* .domainUrl */ .HJ)("".concat(dbName, "/storage/").concat(domain, "/").concat(image))
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:title",
                                content: fb_title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:description",
                                content: fb_desc
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:keywords",
                                content: y_key
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:image",
                                content: (0,_helper__WEBPACK_IMPORTED_MODULE_5__/* .domainUrl */ .HJ)("".concat(dbName, "/storage/").concat(domain, "/").concat(image))
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:url",
                                content: (0,_helper__WEBPACK_IMPORTED_MODULE_5__/* .domainUrl */ .HJ)(canonicalUrl)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:locale",
                                content: selectedLocale
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:site_name",
                                content: siteName
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                rel: "canonical",
                                href: (0,_helper__WEBPACK_IMPORTED_MODULE_5__/* .domainUrl */ .HJ)(canonicalUrl)
                            }),
                            (locales === null || locales === void 0 ? void 0 : locales.length) > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                        rel: "alternate",
                                        href: (0,_helper__WEBPACK_IMPORTED_MODULE_5__/* .domainUrl */ .HJ)("".concat(dbName).concat(meta_url)),
                                        hrefLang: "x-default"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                        rel: "alternate",
                                        href: (0,_helper__WEBPACK_IMPORTED_MODULE_5__/* .domainUrl */ .HJ)("".concat(dbName).concat(meta_url)),
                                        hrefLang: defaultLangCode
                                    }),
                                    locales.map(function(intl) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                            rel: "alternate",
                                            href: (0,_helper__WEBPACK_IMPORTED_MODULE_5__/* .domainUrl */ .HJ)("".concat(dbName, "/").concat(intl.code).concat(meta_url)),
                                            hrefLang: intl.code
                                        });
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ForCWV_CustomCategoryPage__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        brandList: brandList,
                        productsList: productsList,
                        dbName: dbName,
                        titleCategory: titleCategory,
                        categoryDescription: categoryDescription,
                        selectedRate: selectedRate,
                        translationsData: translationsData,
                        breadcrumb: breadcrumb,
                        blockStyleHandle: blockStyleHandle,
                        hasFilterInQuery: hasFilterInQuery,
                        domain: domain,
                        selectedLocale: selectedLocale,
                        backOrderValue: backOrderValue,
                        whichOneRender: whichOneRender,
                        getBuilderData: getBuilderData,
                        showBuilderData: showBuilderData,
                        currencies: currencies,
                        showWishlist: showWishlist,
                        showCart: showCart,
                        isMobile: isMobile,
                        recaptchaActive: recaptchaActive
                    })
                ]
            })
        }))
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Catalog);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3061,7838,9322,3997,4531,5099,9774,2888,179], function() { return __webpack_exec__(24656); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);